module.exports = __webpack_public_path__ + "static/img/testimonial-1.9b7b45f1.jpg";